/*
|--------------------------------------------------------------------------
| School Closings
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
 __gh__webApp.schoolClosings = {
	
	/**
	 * Show Alert Callback
	 */
	"showAlertCallback": function(options){
		var injectView 	= __gh__webApp.utilities.fetch.handlebarsView.append,
			json 		= ("json" in options) ? options.json : null,
			domain		= __gh__coreData.siteData.domain,
			callback 	= ("callback" in options) ? options.callback : null;
			
		
		if (!json.success){ 
			
			if (callback){
				callback();
			}
			
			return; 
		}
		
		injectView({
			"dom"	: $("#content .alert")[0],
			"view"	: "alerts/default",
			"data"	:{
				"class"	: "alert-school",
				"link"	: "http://media.cantonrep.com/closings/?site="+domain,
				"title"	: "School closings",
				"icon"	: "fa-bell"
			}
		});
		
		
		if (callback){
			callback();
		}
		
	},
	
	
	/**
	 * Shows the school closings alert in the alert bar
	 */
	"showAlert": function(callback){
		var commonJS	= __gh__webApp.common,
			isEnabled	= commonJS.getObjectProperty(__gh__coreData["3rdPartyData"],"schoolClosings.enableAlert"),
			fetchJSON 	= __gh__webApp.utilities.fetch.json.get,
			data		= (callback) ? {"callback":callback} : {};
		
		if (!isEnabled) { 
			if (callback){
				callback();
			}
			return; 
		}
				
		fetchJSON({
			"async": true,
			"url": "http://media.cantonrep.com/closings/check.php?callback=__gh__jsonp&jsonp=true",
			"callbacks":[{"callback":"__gh__webApp.schoolClosings.showAlertCallback","data":data}]
		});
	}
};